export const FEES = {
  SPAM_MITIGATION_LAMPORTS: BigInt(5_000),
  NETWORK_FEE_LAMPORTS: BigInt(0),
  MICRO_LAMPORTS_PER_LAMPORT: 1_000_000,
};

export const RATCHETING = {
  MAX_LOCAL_VIEW_KEYS: 5,
  MAX_LOCAL_KYBER_KEYS: 5,
  STORE_NAME: 'ratchetedConversationKeys',
  STORE_KEY_PATH: 'compoundKey',
}

export const MESSAGES_TYPES = {
  0: 'MESSAGE_TYPE_HANDSHAKE_REQUEST',
  1: 'MESSAGE_TYPE_HANDSHAKE_CONFIRM',
  2: 'MESSAGE_TYPE_TEXT',
  129: 'MESSAGE_TYPE_MEDIA',
  MESSAGE_TYPE_HANDSHAKE_REQUEST: 0,
  MESSAGE_TYPE_HANDSHAKE_CONFIRM: 1,
  MESSAGE_TYPE_TEXT: 2,
  MESSAGE_TYPE_MEDIA: 129,
}

export const MATCHER_ENDPOINTS = {
  // local
  //POW_ENDPOINT: "https://127.0.0.1:3030/pow",
  //WS_ENDPOINT: "https://127.0.0.1:3030/ws",


  POW_ENDPOINT: "https://node1.matcher-core.unlink.chat:443/pow",
  WS_ENDPOINT: "https://node1.matcher-core.unlink.chat:443/ws",
}